/* eslint-disable @next/next/no-img-element */
"use client";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Link from "next/link";
import { GoArrowRight } from "react-icons/go";

export const dynamic = "force-dynamic";

export const GameProjectSlider = ({ content, path }) => {
    // var settings = {
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: true,
    //     autoplay: true,
    //     autoplaySpeed: 1800,
    // };
    return (
        <>
            <div className="mt-10">
                <div className="w-full">
                    {content?.map((element) => (
                        <div className="w-full xl:relative" key={element?.id}>
                            {/* Full-width image first */}
                            <div className="xl:block hidden w-full">
                                <img
                                    src={`/assets/${path}/${element?.image}.png`}
                                    alt={element?.alt}
                                    className="w-full object-fill h-[45rem]"
                                />
                            </div>

                            {/* Content positioned above the image and to the left */}
                            <div className="xl:absolute md:top-28 2xl:left-44 xl:left-36 lg:left-14 xl:w-[30%] w-full sm:p-6 p-3 md:mt-2 xl:ml-10 text-center xl:text-start">
                                {/* Game Title */}
                                <h2 className="md:text-3xl text-2xl md:leading-10 leading-8 font-bold text-[#043E86] mb-2">
                                    {element?.title}
                                </h2>

                                {/* Game Description */}
                                <p className="text-[#333333] text-[15px] font-normal leading-4 xl:px-0 md:px-12">
                                    {element?.description}
                                </p>

                                {/* Middle Images (Bullets) */}
                                <div className="xl:flex hidden flex-wrap my-14">
                                    {element?.middleImg?.map((img, index) => (
                                        <img
                                            key={index}
                                            src={`/assets/${path}/${img}.png`}
                                            alt="bullet"
                                            className="h-16 w-16 mr-2"
                                        />
                                    ))}
                                </div>

                                {/* Key Descriptions */}
                                <div className="space-y-2">
                                    {element?.keyDescription?.map((item) => (
                                        <div key={item?.id}>
                                            <span className="font-semibold text-black sm:text-xl text-lg sm:leading-7 leading-6 font-inter">
                                                {item?.key}:{" "}
                                            </span>
                                            <span
                                                className={`font-medium text-black sm:text-lg text-base sm:leading-6 leading-5 font-inter break-all`}
                                            >
                                                {item?.value}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                {/* Redirect Link button */}
                                {element?.btnName && element?.btnLink && (
                                    <>
                                        <div className="my-3 w-full flex xl:justify-start xl:items-start mx-auto">
                                            <Link
                                                href={element?.btnLink}
                                                className="font-mono text-base text-white py-2 px-5 bg-[#1C54A9] shadow-[0px_0px_10px_0px_#1E4E97B2] rounded break-keep w-fit flex justify-center items-center gap-2.5 transition-transform duration-300 hover:scale-110 ease-in-out"
                                            >
                                                {element?.btnName}
                                                <span>
                                                    <GoArrowRight className="text-2xl" />
                                                </span>
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

// {
//     /* old slider code */
// }
// {
//     /* <div className="mt-10">
//                 <Slider
//                     {...settings}
//                     className="z-0 overflow-x-hidden overflow-y-hidden w-full "
//                 >
//                     {content?.map((element) => {
//                         return (
//                             <div
//                                 className="overflow-hidden  w-full h-full"
//                                 key={element?.id}
//                             >
//                                 <img
//                                     src={`/assets/${path}/${element?.image}.png`}
//                                     alt={element?.alt}
//                                     className="overflow-hidden w-full h-[45rem]"
//                                 />
//                             </div>
//                         );
//                     })}
//                 </Slider>
//             </div> */
// }

// old json data
// { "section7": {
//   "title": "Our Game Projects",
//   "subtitle": "",
//   "description": "Our 3D animation studio takes pride in creating visually striking and captivating animations for a wide range of industries. From cinematic sequences to architectural visualizations and product showcases, our portfolio highlights our creative and technical expertise.",
//   "services": [
//       {
//           "id": 1,
//           "image": "Our Game Projects",
//           "alt": "Our Game Projects"
//       },
//       {
//           "id": 2,
//           "image": "Our Game Projects",
//           "alt": "Our Game Projects"
//       },
//       {
//           "id": 3,
//           "image": "Our Game Projects",
//           "alt": "Our Game Projects"
//       }
//   ]
// },}
